import React, { Component } from 'react';
import AuthService from '../../AuthService';
import constants from '../../../config';
import { resolveCardImage } from '../../../utils/resolveImage';
import { formatDate } from './formatters';

var Auth = new AuthService();

class UserListingsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listings: [],
      pagination: { page: 1, limit: 20, total: 0, pages: 0 },
      loading: true,
      filter: '',
    };
    this.fetchListings = this.fetchListings.bind(this);
  }

  componentDidMount() {
    this.fetchListings(1);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId) {
      this.fetchListings(1);
    }
  }

  fetchListings(page) {
    var self = this;
    self.setState({ loading: true });
    var url = constants.DOMAIN + '/api/v1/admin/users/' + self.props.userId + '/listings?page=' + page + '&limit=20';
    if (self.state.filter) url += '&status=' + self.state.filter;
    Auth.fetch(url)
      .then(function(data) {
        self.setState({ listings: data.listings || [], pagination: data.pagination || {}, loading: false });
      })
      .catch(function(err) {
        console.log('Failed to fetch user listings:', err);
        self.setState({ loading: false });
      });
  }

  render() {
    var self = this;
    var listings = this.state.listings;
    var pagination = this.state.pagination;

    return (
      <div>
        {/* Filter */}
        <div className="tw-flex tw-gap-2 tw-mb-4">
          {['', 'active', 'sold'].map(function(f) {
            var label = f === '' ? 'All' : f === 'active' ? 'Active' : 'Sold';
            var isActive = self.state.filter === f;
            return (
              <button
                key={f}
                className={'tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-full tw-border tw-cursor-pointer ' + (isActive ? 'tw-text-white tw-border-transparent' : 'tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa]')}
                style={isActive ? { backgroundColor: '#D4A843' } : {}}
                onClick={function() { self.setState({ filter: f }, function() { self.fetchListings(1); }); }}
              >
                {label}
              </button>
            );
          })}
        </div>

        {this.state.loading && (
          <div className="tw-text-center tw-py-8">
            <i className="fa fa-circle-o-notch fa-spin tw-text-xl tw-mb-2" style={{ color: '#D4A843', display: 'block' }} />
            <span className="tw-text-xs tw-text-[#999]">Loading listings...</span>
          </div>
        )}

        {!this.state.loading && listings.length === 0 && (
          <div className="tw-text-center tw-py-8">
            <i className="fa fa-tag tw-text-2xl tw-mb-2" style={{ color: '#ccc', display: 'block' }} />
            <p className="tw-text-sm tw-text-[#999] tw-m-0">No listings found</p>
          </div>
        )}

        {!this.state.loading && listings.length > 0 && (
          <div className="tw-space-y-3">
            {listings.map(function(listing) {
              var image = resolveCardImage(listing.cardImage) || (listing.images && listing.images[0] ? resolveCardImage(listing.images[0]) : null);
              return (
                <div key={listing._id} className="tw-p-3 tw-rounded-lg tw-border tw-border-[#eee] dark:tw-border-[#222]">
                  <div className="tw-flex tw-items-start tw-gap-3">
                    {image ? (
                      <img src={image} alt="" className="tw-w-10 tw-h-10 tw-rounded-lg tw-object-cover tw-flex-shrink-0" />
                    ) : (
                      <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#f0f0f0' }}>
                        <i className="fa fa-image tw-text-[#ccc]" />
                      </div>
                    )}
                    <div className="tw-flex-1 tw-min-w-0">
                      <div className="tw-text-sm tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white tw-truncate">{listing.title}</div>
                      <div className="tw-flex tw-items-center tw-gap-2 tw-mt-1 tw-flex-wrap">
                        <span className="tw-text-xs tw-font-semibold" style={{ color: '#D4A843' }}>${(listing.price || 0).toFixed(2)}</span>
                        {listing.sold ? (
                          <span className="tw-text-xs tw-px-1.5 tw-py-0.5 tw-rounded tw-font-medium tw-text-white" style={{ backgroundColor: '#6B7280' }}>Sold</span>
                        ) : (
                          <span className="tw-text-xs tw-px-1.5 tw-py-0.5 tw-rounded tw-font-medium tw-text-white" style={{ backgroundColor: '#10B981' }}>Active</span>
                        )}
                        {listing.category && (
                          <span className="tw-text-xs tw-text-[#999]">{listing.category}</span>
                        )}
                        {listing.reportedCount > 0 && (
                          <span className="tw-text-xs tw-px-1.5 tw-py-0.5 tw-rounded tw-font-medium tw-text-white" style={{ backgroundColor: '#EF4444' }}>
                            <i className="fa fa-flag tw-mr-1" style={{ fontSize: 9 }} />{listing.reportedCount} report{listing.reportedCount !== 1 ? 's' : ''}
                          </span>
                        )}
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-3 tw-mt-1.5 tw-text-xs tw-text-[#999]">
                        <span>{listing.createdAt ? formatDate(listing.createdAt) : ''}</span>
                        {listing.shipping != null && (
                          <span>{listing.shipping > 0 ? '$' + listing.shipping.toFixed(2) + ' shipping' : 'Free shipping'}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {pagination.pages > 1 && (
          <div className="tw-flex tw-justify-between tw-items-center tw-mt-4 tw-pt-3 tw-border-t tw-border-[#eee] dark:tw-border-[#222]">
            <span className="tw-text-xs tw-text-[#999]">{pagination.total} total</span>
            <div className="tw-flex tw-gap-1">
              <button
                className="tw-px-3 tw-py-1.5 tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-40"
                disabled={pagination.page <= 1}
                onClick={function() { self.fetchListings(pagination.page - 1); }}
              >Prev</button>
              <button
                className="tw-px-3 tw-py-1.5 tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-40"
                disabled={pagination.page >= pagination.pages}
                onClick={function() { self.fetchListings(pagination.page + 1); }}
              >Next</button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default UserListingsTab;
